/**
 * Kleiner Umschalter zwischen heller und dunkler Ansicht. Zeigt immer das
 * Zeichen der Ansicht, in die geklickt wird – nicht der aktuellen.
 */
export default function ThemeToggle({ theme, onToggle }) {
  const toDark = theme !== "dark";
  const label = toDark ? "Dunkle Ansicht" : "Helle Ansicht";

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={onToggle}
      title={label}
      aria-label={label}
    >
      {toDark ? (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <path
            d="M20 14.2A8.4 8.4 0 0 1 9.8 4 8.4 8.4 0 1 0 20 14.2Z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="4.1" stroke="currentColor" strokeWidth="1.7" />
          <path
            d="M12 2.6v2.3M12 19.1v2.3M2.6 12h2.3M19.1 12h2.3M5.3 5.3l1.7 1.7M17 17l1.7 1.7M18.7 5.3 17 7M7 17l-1.7 1.7"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
        </svg>
      )}
    </button>
  );
}
